import { BACKEND_URL } from 'configs'

import { ClusteringExecutionResponse } from 'tabs/topQuestions/lib/question_clustering_status/questionClusteringStatusTypes'

export class HistoricalDataApiException extends Error {

  constructor(public botId: number,
              public executionId: string,
              message?: string) {
    super(message || 'Failed to fetch historical data')
  }
}

export class HistoricalDataNotFoundException extends HistoricalDataApiException {

  constructor(public botId: number,
              public executionId: string) {
    super(botId, executionId, 'Historical data does not exist for the period')
  }
}

export async function fetchTopQuestionHistoricalData(botId: number,
                                                     executionId: string): Promise<ClusteringExecutionResponse> {
  const urlComponents = new URLSearchParams()
  urlComponents.append('executionId', '' + executionId)

  const url = `${BACKEND_URL}/bot/${botId}/questions-clustering/historical-data?` + urlComponents.toString()
  const response = await fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  })
  if (response.status == 200) {
    return await response.json() as ClusteringExecutionResponse
  } else if (response.status == 404) {
    throw new HistoricalDataNotFoundException(botId, executionId)
  } else {
    throw new HistoricalDataApiException(botId, executionId)
  }
}


